import React from "react"
import PropTypes from "prop-types"
import {Box} from "@mui/material"
import FormSectionAccordion from "src/v2/components/FormSectionAccordion"
import theme from "src/v2/theme/theme"
import {ReactComponent as CheckIcon} from "src/v2/assets/icons/check-icon.svg"
import { renderGrid } from "src/v2/components/FieldRenderer"
import {datasFields} from "./constants"

const DatasSection = ({
    state,
    setSectionField,
    actions,
    defaultOpen = false,
    syncToken = 0,
    autoCompleteController = {},
}) => {
    return (
        <Box sx={{mt: 0}}>
            <FormSectionAccordion
                title="Datas e Valor Nominal"
                icon={<CheckIcon style={{color: theme.palette.icon.main, width: 20, height: 20}} />}
                actions={actions}
                defaultOpen={defaultOpen}
                syncToken={syncToken}
                disableBorder={true}
            >
                {renderGrid(
                    datasFields,
                    state,
                    (key) => (value) => setSectionField("datas", key, value),
                    undefined,
                    undefined,
                    (key, value) => setSectionField("datas", key, value),
                    autoCompleteController
                )}

            </FormSectionAccordion>
        </Box>
    )
}

DatasSection.propTypes = {
    state: PropTypes.object.isRequired,
    setSectionField: PropTypes.func.isRequired,
    actions: PropTypes.node,
    defaultOpen: PropTypes.bool,
    syncToken: PropTypes.number,
    autoCompleteController: PropTypes.object,
}

export default DatasSection